import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EquipmentItemListSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/equipment/_layout/items/')({
  validateSearch: zodValidator(EquipmentItemListSearchSchema)
});